import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel, type Model } from '@patsnap/tahiti-core/common/model';
import { DEFAULT_LANGUAGE } from '../constants';
import { LangTypeMode } from '../type/translation.enum';
import type { TranslationSettings } from '../type/translation.type';

export const TranslationSettingModel = Symbol('TranslationSettingModel');

export interface TranslationSettingModel extends Model<TranslationSettings> {}

const DEFAULT_VALUE = {
    lang: DEFAULT_LANGUAGE,
    langType: LangTypeMode.DEFAULT,
    isActivated: false,
    isVisible: false,
}

@injectable()
export class TranslationSettingModelImpl extends AbstractModel<TranslationSettings> implements TranslationSettingModel {
    protected _modelData: TranslationSettings = {
        left: { ...DEFAULT_VALUE },
        right: { ...DEFAULT_VALUE },
    };
}
